import axios from 'axios'
import { queryParam, Response } from './_model'
import { FileModel } from '@velocity/shared'

export const delete_file_api = async (id: string) => {
  return await axios.delete(`${process.env.REACT_APP_BASE_URL}/file/?id=${id}`)
}

export const import_data = async (data: {
  media: FileModel
  model: string
}): Promise<any> => axios.post(`${process.env.REACT_APP_BASE_URL}/import`, data)

export const notification_api = async (
  data: queryParam
): Promise<Response<NotificationModel[]>> =>
  axios.get(
    `${process.env.REACT_APP_BASE_URL}/notification?${data.queryKey[1] || ''}`
  )
export const update_notification_api = async (data: {
  id: string
  read_status: boolean
}) =>
  axios.put(`${process.env.REACT_APP_BASE_URL}/notification/${data.id}`, data)

export const get_request_api = async (data: any) =>
  (await axios.get(
    `${process.env.REACT_APP_BASE_URL}/${data.queryKey[0]}${data.queryKey[1] ? '?' + data.queryKey[1] : ''}`
  )) as any
export const get_request_api_v2 = async (data: any) =>
  (await axios.get(`${process.env.REACT_APP_BASE_URL}/${data.queryKey[0]}`, {
    params: data.queryKey[1]
  })) as any

type NotificationModel = {
  id: string
  title: string
  model: string
  operation: string
  status: boolean
  extra: any
  created_at: string
  updated_by: string
  business_id: string
}
